export default "__VITE_ASSET__BAGUPkcV__"